import { DataAccessFactory } from './DataAccessFactory'
import { Resource } from './dataAccess'

class GdprFactory extends DataAccessFactory {

    constructor() {
        super()

        this.defaultActions = {}
        this.server = 'gdpr'
        this.initialize()
    }


    initialize() {
        const resources: Array<Resource> = [
            {
                name: 'GdprStatus',
                url: 'gdprStatus/:userId'
            },
            {
                name: 'RtbfStatus',
                url: 'rtbfStatus/:userId',
                actions: {
                    approve: {
                        method: 'POST',
                        url: 'rtbfStatus/:userId/approve',
                        isArray: true,
                    },
                    decline: {
                        method: 'POST',
                        url: 'rtbfStatus/:userId/decline',
                        isArray: true,
                    },
                    get: {
                        method: 'GET',
                        url: 'rtbfStatus/:applicationId',
                        params: {
                            applicationId: '@applicationId'
                        }
                    },
                    save: {
                        method: 'POST',
                        url: 'rtbfStatus/:applicationId',
                        params: {
                            applicationId: '@applicationId'
                        }
                    }
                }
            }
        ]

        this.process(resources)
    }

}

new GdprFactory()
